<template>
    <div class="home-box grey-box" style="padding: 0 1rem">
        <div style="height: 2rem"></div>
        <div v-if="activity">
            <cell-group style="margin: 1rem 0" title="活动信息">
                <cell title="活动名称" :value="activity.activityName"/>
<!--                <cell title="参与人数" :value="activity.numberPeople"/>-->
                <cell title="开始时间" :value="ptime(activity.activityStartTime)"/>
                <cell title="结束时间" :value="ptime(activity.activityEndTime)"/>
                <div class="ql-container ql-snow" style="border:none">
                    <div class="ql-editor" data-gramm="false" contenteditable="true"
                         v-html="activity.activityContent">
                    </div>
                </div>
            </cell-group>
            <div style="text-align: end;color: #aaaaaa">
                点击”我要报名“自动填写本人信息
                <ant-button type="info" @click="iWantToSignUp" round size="small">我要报名</ant-button>
            </div>
            <cell-group style="margin: 1rem 0" title="报名人员">

                <ant-form validate-first @submit="onSubmit"  >
                    <div v-for="(v,i) in form" :key="i">
                        <divider dashed>参加人员{{i+1}}</divider>
                        <row type="flex" justify="end" style="padding-right: 1rem">
                            <ant-button type="danger" size="mini" round @click="clearForm(i)"
                                        v-if="i!= 0">删除人员
                            </ant-button>
                            <ant-button type="info" size="mini" round @click="addForm" v-if="i== form.length-1">为他人报名
                            </ant-button>
                        </row>
                        <ant-field label="公司：" v-model="v.company" required
                                   :rules="[{ required: true , message: '请填写您所在的公司名' }]"
                                   placeholder="请输入内容"/>
                        <ant-field label="部门：" v-model="v.department" required
                                   :rules="[{ required: true , message: '请填您所在的部门名' }]"
                                   placeholder="请输入内容"/>
                        <ant-field label="姓名：" v-model="v.userName" required
                                   :rules="[{ required: true , message: '请填写姓名' }]"
                                   placeholder="请输入内容"/>
<!--                        <ant-field label="出发地点：" v-model="v.startingPoint"-->
<!--                                   :rules="[{ required: true , message: '请填写出发地点' }]"-->
<!--                                   placeholder="请输入内容"/>-->
                        <ant-field label="联系方式："
                                   v-model="v.phone"
                                   required type="tel"
                                   placeholder="请输入联系方式"
                                   :rules="[{ pattern, message: '请填写手机号' }]"/>
                        <ant-field label="备注："
                                   v-model="v.remark"
                                   rows="2"
                                   autosize
                                   type="textarea"
                                   maxlength="100"
                                   placeholder="请输入内容"
                                   show-word-limit/>
                    </div>
                    <div style="margin: 16px;">
                        <ant-button round block type="danger" native-type="submit" :loading="loading">
                            报名
                        </ant-button>
                    </div>

                </ant-form>
<!--                <picker-->
<!--                        title="请选择活动类型"-->
<!--                        v-show="showType"-->
<!--                        show-toolbar-->
<!--                        :columns="columns"-->
<!--                        @confirm="onConfirm"-->
<!--                        @cancel="onCancel"-->
<!--                />-->
            </cell-group>
        </div>
        <empty description="活动尚未开始" v-else/>
    </div>
</template>

<script>
    //活动报名
    import service from "../../api/service";
    import {Button, Cell, CellGroup, Field, Form, Icon, Col, Row, Divider, Toast, Empty, Picker} from 'vant'
    import moment from "moment";

    export default {
        name: "eventRegistration",
        components: {
            VanButton: Button,
            Cell,
            CellGroup,
            AntField: Field,
            AntForm: Form,
            AntButton: Button,
            Icon,
            Col,
            Row,
            Divider, Empty,Picker
        },
        props: {
            proId: '',
            openid: '',
        },
        data() {
            return {
                loading: false,
                activity: {},
                showType: false,
                columns: ['地点一', '地点二', '地点三', '地点四', '地点五'],
                form: [{
                    activityId: this.proId,
                    phone: '',
                    userName: '',
                    company: '',
                    department: '',
                    remark: '',
                    openid: sessionStorage.getItem("openid"),
                    participation: 1,
                    // startingPoint:'',

                }],
                pattern: /\d{11}/,
                user: {}
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            //初始化
            init() {
                service.get('/api/activity/getById',
                    {id: this.proId}).then(res => {
                    if (res.status === 200) {
                        this.activity = res.data
                        sessionStorage.setItem("activityName", this.activity.activityName)
                    }
                })
                service.get('/api/gzh/getUserByOpenid', {
                    openid: sessionStorage.getItem("openid")
                }).then(res => {
                    if (res.status === 200) {
                        this.user = res.data
                    }
                })
            },
            ptime(v) {
                let d = Number(v)
                return v ? moment(d).format("YYYY-MM-DD HH:mm:ss") : '-';
            },
            // onCancel() {
            //     this.showType = false
            // },
            // onConfirm(value, index) {
            //     this.showType = false
            //     this.form[0].startingPoint = value;
            // },
            // setMotionGroup() {
            //     this.showType = true
            // },
            //我要帮名
            iWantToSignUp() {
                this.form = [{
                    activityId: this.proId,
                    phone: this.user.phone,
                    userName: this.user.userName,
                    company: this.user.deptName,
                    department: this.user.department,
                    remark: '',
                    openid: sessionStorage.getItem("openid"),
                    participation: 1
                }]
            },
            //提交保单
            onSubmit(errorInfo) {
                let form = [...this.form]
                this.loading = true
                service.post('/api/activity/apply', {list: form}).then(res => {
                    this.loading = false
                    if (res.status === 200) {
                        Toast.success("报名成功")
                        sessionStorage.setItem("proId", this.proId)
                        this.$router.push({path: '/carList'})
                    } else {
                        Toast.fail(res.message)
                    }
                })
            },
            //添加活动人员
            addForm() {
                this.form.push({
                    activityId: this.proId,
                    phone: '',
                    userName: '',
                    remark: '',
                    openid: sessionStorage.getItem("openid"),
                    participation: 1
                })
            },
            //删除活动人员
            clearForm(i) {
                this.form.splice(i, 1);
            }
        }

    }
</script>

<style scoped>

</style>